export default "__VITE_ASSET__CwWRI498__"